(function() {

  document.addEventListener('theme:cart:popdown', function(e) {
    e.stopImmediatePropagation();
    var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (cartDrawer) {
      cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }, true);

})();
